import createSvgIcon from '@mui/material/utils/createSvgIcon.js';
import React from 'react';

export default createSvgIcon(
  <path d="M20.0423 3.9577 7.6816 2 2 13.1507 10.8493 22 22 16.3184zm-.3099 9.8077-2.8126 3.2588-2.8135 1.4335 5.371-6.3035zm.1919 1.2114.0757.478-.8535.4348zm-.6358-4.0144-7.4791 8.6657-.73.3719-.6151-.6151 8.5659-10.0533zm-.444-2.8029L9.7622 18.6828l-.758-.758 9.6021-11.2694zM6.7622 15.6828l-.9177-.9178 8.2185-9.6455.0342-.2402 1.75.2772zm.702.702 9.4264-11.063 1.4753.2336L8.299 17.2195zM4.3845 13.305l7.4804-8.7792 1.3431.2127-8.056 9.334zm.4515-2.025L8.5453 4l2.2643.3586z" />,
  'Area',
);
